import React from 'react';
import PropTypes from 'prop-types';
import Location from '../../core/Location';
import {windowScrollY, getNoScrollLocationState} from '../../utils/DOMUtils';

const ESC_KEY_CODE = 27;
export default ComposedComponent => 
  class popupBehaviour extends React.Component {
    static propTypes = {
      onClose: PropTypes.func,
      overrideOnClose: PropTypes.bool,
      popupQueryIdentifier: PropTypes.string,
    };

    closePopup = e => {
      if (this.props.overrideOnClose) {
        this.props.onClose(e);
        return;
      }
      const currentLocation = Location.getCurrentLocation();
      const query = Object.assign({}, currentLocation.query);

      delete query[this.props.popupQueryIdentifier || 'showPopup'];

      Location.push({
        pathname: currentLocation.pathname,
        state: getNoScrollLocationState(),
        query,
      });
      if (this.props.onClose) {
        this.props.onClose(e);
      }
    };
    handleWindowKeyUp = (e) => {
      if (e.keyCode === ESC_KEY_CODE) {
        this.closePopup(e);
      }
    };
    render() {
      const {onClose, overrideOnClose, popupQueryIdentifier, ...props} = this.props;
      return <ComposedComponent {...props} onClose={this.closePopup}/>;
    }
};



// WEBPACK FOOTER //
// ./src/components/Popup/popupBehaviour.js